export default __webpack_public_path__ + "icon_rain.84c38220e61fcf5b13faf4f2139462ce.svg";